export { default as assert } from './assert';
export { default as deepArrayEqual } from './deep-array-equal';
export { isWebGL2, isObjectEmpty } from './utils';
//# sourceMappingURL=index.js.map